// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import hi from './hi.json';
import mr from './mr.json';
import gu from './gu.json';

const storedLanguage = localStorage.getItem('selectedLanguage');
const validLanguages = ['en', 'mr', 'hi', 'gu'];
const defaultLanguage = validLanguages.includes(storedLanguage) ? storedLanguage : 'mr';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      hi: { translation: hi },
      mr: { translation: mr },
      gu: { translation: gu }
    },
    lng: defaultLanguage, // Set language from localStorage or default
    fallbackLng: 'en', // If a key is missing, fallback to English
    interpolation: {
      escapeValue: false // React already safes from XSS
    }
  });

export default i18n;
